export default class MedicalActProtocolRule {
	static constructRequestBody(medicalActs, ruleName) {
		const ruleTemplate = {
			taskType: 'MedicalActsClinicalApproval',
			name: ruleName,
			enabled: true,
			ruleType: 'AutomationRule',
		}

		const MedicalActProtocolRules = medicalActs?.map(
			({ quantity, medicalActId, serviceProviderId }, idx) => ({
				...ruleTemplate,
				order: idx,
				rule: [
					[
						{
							option: 'alreadyApprovedCount',
							type: 'lessThan',
							value: `${quantity}`,
						},
						{
							option: 'requestState',
							type: 'in',
							value: ['2', '3'],
						},
						{ option: 'branch', type: 'in', value: ['AT', 'AV'] },
						{
							option: 'medicalActId',
							type: 'in',
							value: [medicalActId],
						},
					],
				],
				output: {
					automate: true,
					metadata: serviceProviderId ? [serviceProviderId] : [],
				},
			})
		)

		return {
			ruleType: 'AutomationRule',
			taskType: 'MedicalActsClinicalApproval',
			rules: MedicalActProtocolRules,
		}
	}

	static retrieveRuleValues(processProtocols) {
		return processProtocols?.map(({ rule, output }) => {
			const quantity = parseInt(
				rule[0].find(({ option }) => option === 'alreadyApprovedCount')
					?.value?.[0] ?? 0,
				10
			)
			const medicalActId =
				rule[0].find(({ option }) => option === 'medicalActId')
					?.value?.[0] ?? ''
			const serviceProviderId = output.metadata?.[0] ?? ''

			return { quantity, medicalActId, serviceProviderId }
		})
	}
}
